export default "__VITE_ASSET__Mf3Gc2Xw__"